// src/features/business-functions/state/workspaceAtoms.js
import { atom } from 'recoil';
import { DEFAULT_WORKSPACE_TAB } from '../constants/workspaceConstants';

/** Workspace detail object */
export const workspaceDetailAtom = atom({
  key: 'bf_workspaceDetailAtom_v1',
  default: null,
});

/** Workspace tables list */
export const workspaceTablesAtom = atom({
  key: 'bf_workspaceTablesAtom_v1',
  default: [],
});

/** Active workspace tab key */
export const workspaceActiveTabAtom = atom({
  key: 'bf_workspaceActiveTabAtom_v1',
  default: DEFAULT_WORKSPACE_TAB,
});
